import { Box } from '@material-ui/core';
import {
  FavoriteShortcut,
  ShortcutLink,
  ShortcutSection,
  ViewMode,
} from '../../types';
import { RenderSections, FavoriteSection } from '../molecules/';

type Props = {
  searchQuery: string;
  filteredSections: ShortcutSection[];
  favoriteShortcuts: FavoriteShortcut[];
  favoriteIds: string[];
  hasAnyFavorites: boolean;
  favoritesLoaded: boolean;
  toggleFavorite: (link: ShortcutLink) => void;
  isReorderingFavorites?: boolean;
  onReorderFavorites?: (links: ShortcutLink[]) => void;
  onEditCustomLink?: (link: ShortcutLink) => void;
  onDeleteCustomLink?: (link: ShortcutLink) => void;
  viewMode: ViewMode;
};

export const SectionList = ({
  searchQuery,
  filteredSections,
  favoriteShortcuts,
  favoriteIds,
  hasAnyFavorites,
  favoritesLoaded,
  toggleFavorite,
  viewMode,
  isReorderingFavorites = false,
  onReorderFavorites,
  onEditCustomLink,
  onDeleteCustomLink,
}: Props) => {
  return (
    <Box>
      <FavoriteSection
        viewMode={viewMode}
        favorites={favoriteShortcuts}
        hasAnyFavorites={hasAnyFavorites}
        favoritesLoaded={favoritesLoaded}
        searchQuery={searchQuery}
        toggleFavorite={toggleFavorite}
        isReorderingFavorites={isReorderingFavorites}
        onReorderFavorites={onReorderFavorites}
      />
      <RenderSections
        searchQuery={searchQuery}
        filteredSections={filteredSections}
        favoriteIds={favoriteIds}
        toggleFavorite={toggleFavorite}
        viewMode={viewMode}
        onEditCustomLink={onEditCustomLink}
        onDeleteCustomLink={onDeleteCustomLink}
        actionsDisabled={isReorderingFavorites}
      />
    </Box>
  );
};
